import { render, staticRenderFns } from "./Batchage.vue?vue&type=template&id=730aa48e&scoped=true"
import script from "./Batchage.vue?vue&type=script&lang=js"
export * from "./Batchage.vue?vue&type=script&lang=js"
import style0 from "./Batchage.vue?vue&type=style&index=0&id=730aa48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730aa48e",
  null
  
)

export default component.exports